import type { SuperProperties, PluginData } from '../analytics.model'
import { getCookieValue } from 'utils/getCookieValue'

/**
 * Custom heap analytics plugin:
 * https://getanalytics.io/plugins/writing-plugins/
 * https://developers.heap.io/docs/web
 */
export const heap = (heapAppId: string, heapSuperProperties: SuperProperties) => ({
  name: 'heap',
  config: {
    ...heapSuperProperties,
    campaignType: 'studio',
  },
  initialize({ config: superProperties }: PluginData): void {
    if (!!window.heap) {
      window.heap.clearEventProperties()

      // Retrieve Pro Global Device ID cookie
      const pgdid = getCookieValue('pgdid')

      // Add session IDs as a user property for every heap event
      window.heap.addUserProperties({
        ...(pgdid && { pgdid }),
      })

      // Add super properties to every event
      window.heap.addEventProperties({
        ...superProperties,
        ...(pgdid && { pgdid }),
      })
    }
  },
  page({ payload }: PluginData): void {
    const { properties } = payload

    window.heap.track('Page View', properties)
  },
  track({ payload }: PluginData): void {
    const { event, properties } = payload

    if (event) {
      window.heap.track(event, properties)
    }
  },
  identify({ payload }: { payload: { userId: string } }): void {
    const { userId } = payload

    if (userId) {
      window.heap.identify(userId)
    }
  },
  loaded(): boolean {
    return !!window.heap
  },
})
